import {
  clearClientSessionToken,
  decodeLocalSession,
  getClientSessionToken,
} from '../api/authToken';

const listeners = new Set();

function sessionUser() {
  const token = getClientSessionToken();
  const payload = decodeLocalSession(token);
  if (!payload || payload.kind !== 'client') return null;
  return {
    uid: payload.uid,
    email: payload.email || null,
    providerData: [{ providerId: 'password' }],
    getIdToken: async () => getClientSessionToken(),
    getIdTokenResult: async () => ({ claims: {} }),
  };
}

function notify(user) {
  listeners.forEach((cb) => {
    try {
      cb(user);
    } catch {
      // ignore
    }
  });
}

export function notifyClientAuthChanged() {
  notify(sessionUser());
}

export const clientAuth = {
  get currentUser() {
    return sessionUser();
  },
  onAuthStateChanged(cb) {
    return onAuthStateChanged(clientAuth, cb);
  },
  async signOut() {
    clearClientSessionToken();
    notify(null);
  },
};

export const auth = clientAuth;

export function onAuthStateChanged(_auth, cb) {
  cb(sessionUser());
  listeners.add(cb);
  return () => listeners.delete(cb);
}

export async function signOut(authInstance = clientAuth) {
  await authInstance.signOut();
}
